/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { Button, Icon, Popup } from 'semantic-ui-react';

import DroppableTypes from '../../constants/DroppableTypes';
// import DeviceDetailContainer from '../../containers/DeviceDetailContainer';
import DeviceContainer from '../../containers/DeviceContainer';
import NameEdit from './NameEdit';
import DeviceAdd from './DeviceAdd';
import ActionsPopup from './ActionsPopup';
import { ReactComponent as PlusMathIcon } from '../../assets/images/plus-math-icon.svg';

import styles from './Line.module.scss';

const Line = React.memo(
  ({
    siteId,
    id,
    index,
    name,
    isPersisted,
    devices,
    deviceIds,
    deviceOfLine,
    filterLabels,
    canEdit,
    onUpdate,
    onDelete,
    onDeviceUpdate,
  }) => {
    const [t] = useTranslation();
    const [isAddDeviceOpened, setIsAddDeviceOpened] = useState(false);

    const nameEdit = useRef(null);
    const lineWrapper = useRef(null);

    const handleHeaderClick = useCallback(() => {
      if (isPersisted && canEdit) {
        nameEdit.current.open();
      }
    }, [canEdit, isPersisted]);

    const handleNameUpdate = useCallback(
      (newName) => {
        onUpdate({
          name: newName,
        });
      },
      [onUpdate],
    );

    const handleAddDeviceClick = useCallback(() => {
      setIsAddDeviceOpened(!isAddDeviceOpened);
    }, [isAddDeviceOpened]);

    const handleAddDeviceClose = useCallback(() => {
      setIsAddDeviceOpened(false);
    }, []);

    const handleNameEdit = useCallback(() => {
      nameEdit.current.open();
    }, []);

    const handleDeviceAdd = useCallback(() => {
      setIsAddDeviceOpened(true);
    }, []);

    const handleAddDeviceToLine = useCallback(
      (data) => {
        onDeviceUpdate(data);
        setIsAddDeviceOpened(false);
      },
      [onDeviceUpdate],
    );

    useEffect(() => {
      if (isAddDeviceOpened) {
        lineWrapper.current.scrollTop = lineWrapper.current.scrollHeight;
      }
    }, [deviceIds, isAddDeviceOpened, deviceOfLine]);

    const devicesNode = (
      <Droppable
        droppableId={`line:${id}`}
        type={DroppableTypes.DEVICE}
        isDropDisabled={!isPersisted}
      >
        {({ innerRef, droppableProps, placeholder }) => (
          <div {...droppableProps} ref={innerRef}>
            <div className={styles.devices}>
              {/* {deviceOfLine.map((device) => {
                return <DeviceDetailContainer key={device.id} id={device.id} />;
              })} */}
              {deviceIds.map((deviceId, deviceIndex) => (
                <DeviceContainer key={deviceId} id={deviceId} index={deviceIndex} />
              ))}
              {placeholder}
            </div>
          </div>
        )}
      </Droppable>
    );

    return (
      (filterLabels.length <= 0 || deviceIds.length > 0) && (
        <Draggable draggableId={`line:${id}`} index={index} isDragDisabled={!isPersisted}>
          {({ innerRef, draggableProps, dragHandleProps }) => (
            <div {...draggableProps} data-drag-scroller ref={innerRef} className={styles.wrapper}>
              <div {...dragHandleProps} className={styles.header} onClick={handleHeaderClick}>
                <NameEdit ref={nameEdit} defaultValue={name} onUpdate={handleNameUpdate}>
                  <div className={styles.headerName}>{name}</div>
                </NameEdit>
                {isPersisted && canEdit && (
                  <ActionsPopup
                    onNameEdit={handleNameEdit}
                    onDeviceAdd={handleDeviceAdd}
                    onDelete={onDelete}
                  >
                    <Button className={classNames(styles.headerButton, styles.target)}>
                      <Icon fitted name="pencil" size="small" />
                    </Button>
                  </ActionsPopup>
                )}
              </div>
              <div
                ref={lineWrapper}
                className={classNames(
                  styles.lineWrapper,
                  isAddDeviceOpened && styles.lineWrapperFull,
                )}
              >
                <div className={styles.line}>{devicesNode}</div>
              </div>
              {canEdit && (
                <Popup
                  basic
                  position="top center"
                  open={isAddDeviceOpened}
                  trigger={
                    <button
                      type="button"
                      disabled={!isPersisted || !canEdit}
                      className={styles.addDeviceButton}
                      onClick={handleAddDeviceClick}
                    >
                      <PlusMathIcon className={styles.addDeviceButtonIcon} />
                      <span className={styles.addDeviceButtonText}>
                        {deviceIds.length > 0
                          ? t('action.addAnotherDevice')
                          : t('action.addDevice')}
                      </span>
                    </button>
                  }
                  content={
                    <DeviceAdd
                      siteId={siteId}
                      lineId={id}
                      devices={devices}
                      isOpened={isAddDeviceOpened}
                      onCreate={handleAddDeviceToLine}
                      onClose={handleAddDeviceClose}
                    />
                  }
                  on="click"
                  hideOnScroll
                  className={styles.popupAddDevice}
                />
              )}
            </div>
          )}
        </Draggable>
      )
    );
  },
);

Line.propTypes = {
  siteId: PropTypes.string.isRequired,
  devices: PropTypes.arrayOf(PropTypes.any).isRequired,
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  isPersisted: PropTypes.bool.isRequired,
  deviceIds: PropTypes.arrayOf(PropTypes.any).isRequired,
  deviceOfLine: PropTypes.arrayOf(PropTypes.any).isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  onDeviceUpdate: PropTypes.func.isRequired,
  filterLabels: PropTypes.arrayOf(PropTypes.any).isRequired,
  canEdit: PropTypes.bool.isRequired,
};

Line.defaultProps = {
  onDelete: undefined,
};

export default Line;
